export const PACKET_HEADER_BYTES = 8;
export const PACKET_PAYLOAD_SAMPLES = 512;
export const PACKET_BYTES = PACKET_HEADER_BYTES + PACKET_PAYLOAD_SAMPLES * 2;

export type DecodedPacket = {
  seq: number;
  sendTsMs: number;
  samples: Int16Array;
};

export function encodePacket(seq: number, sendTsMs: number, samples: Int16Array): ArrayBuffer {
  const buf = new ArrayBuffer(PACKET_HEADER_BYTES + samples.byteLength);
  const view = new DataView(buf);
  view.setUint32(0, seq >>> 0, true);
  view.setUint32(4, sendTsMs >>> 0, true);
  new Int16Array(buf, PACKET_HEADER_BYTES).set(samples);
  return buf;
}

export function decodePacket(buf: ArrayBuffer): DecodedPacket {
  if (buf.byteLength < PACKET_HEADER_BYTES) {
    throw new Error(`packet too small: ${buf.byteLength} bytes`);
  }
  const view = new DataView(buf);
  const seq = view.getUint32(0, true);
  const sendTsMs = view.getUint32(4, true);
  const payloadLen = (buf.byteLength - PACKET_HEADER_BYTES) >> 1;
  const samples = new Int16Array(buf.slice(PACKET_HEADER_BYTES), 0, payloadLen);
  return { seq, sendTsMs, samples };
}
